<template>
  <ul class="ct-link-list">
    <LinkComponent
      v-for="(link, index) in linksInfo.links"
      :key="`${index}link`"
      v-bind="{ link, isLastItem: index < linksInfo.links.length - 1 }"
    />
  </ul>
</template>

<script setup lang="ts">
import { Links } from "@/types/entrypoints"
import LinkComponent from "@/components/Link/Index.vue"

defineProps<{
	linksInfo: Links
}>()
</script>

<style lang="postcss" scoped>
@reference '#importtailwindcss';

.ct-link-list {
  @apply flex gap-2;
}
</style>
